// applyTheme.js
import  {ColorTheme}  from "./ColorTheme";

export const applyTheme = () => {
  Object.keys(ColorTheme.colors).forEach((key) => {
    document.documentElement.style.setProperty(`--${key}-color`, ColorTheme.colors[key]);
  });
};
